export class ApiUrl {
  //BaseUrl: string = "http://localhost/happyfleetmarmic_api/index.php";
  BaseUrl: string = "https://marmic-api.happyfleets.com/index.php";
  //BaseUrl: string = "http://test-api.happyfleets.com/index.php";
}